'use client';
import { jsx } from 'react/jsx-runtime';
import { renderWithRef } from '../core/render-with-ref.js';
import { RenderComp } from '../core/render-comp.component.js';

const StandardTileSeparatelyClickableContents = renderWithRef('StandardTileSeparatelyClickableContents', null, (t, r)=>jsx(RenderComp, {
        root: "div",
        forwardedRef: r,
        classNames: [
            'swan-standard-tile-separately-clickable-contents'
        ],
        props: t,
        children: t.children
    }));

export { StandardTileSeparatelyClickableContents };
